import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { createUser } from "./thunks/create-user";
import { listRoles } from "./thunks/list-roles";
import { listUsers } from "./thunks/list-users";
import { listZones } from "./thunks/list-zones";
import { updateUser } from "./thunks/update-user";

const name = "users";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // The users read drives the screen's loading/error state.
      .addCase(listUsers.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(listUsers.fulfilled, (state, action) => {
        state.users = action.payload;
        state.isPending = false;
        state.isRejected = false;
      })
      .addCase(listUsers.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      // Roles + zones populate their lists; they don't gate the screen.
      .addCase(listRoles.fulfilled, (state, action) => {
        state.roles = action.payload;
      })
      .addCase(listZones.fulfilled, (state, action) => {
        state.zones = action.payload;
      })
      // Create + update share the saving/error flags (the screen re-reads the
      // list on success, so the array is refreshed there).
      .addCase(createUser.pending, (state) => {
        state.isSaving = true;
        state.saveError = "";
      })
      .addCase(createUser.fulfilled, (state) => {
        state.isSaving = false;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.isSaving = false;
        state.saveError = action.error.message ?? "";
      })
      .addCase(updateUser.pending, (state) => {
        state.isSaving = true;
        state.saveError = "";
      })
      .addCase(updateUser.fulfilled, (state) => {
        state.isSaving = false;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.isSaving = false;
        state.saveError = action.error.message ?? "";
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
